import useSearchResults from './useSearchResults';

export default useSearchResults;
